module.exports = __webpack_public_path__ + "static/media/icon-settings.6520bebb.svg";